
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    /** 是否自动获得焦点 */
    autofocus: { type: Boolean, default: false },
    /** 是否禁用 */
    disabled: { type: Boolean, default: false },
    /** 下方提示文本 */
    hint: { type: String, default: undefined },
    /** 提示文本是否不隐藏 */
    persistentHint: { type: Boolean, default: false },
    /** 字段名 */
    label: { type: String, default: undefined },
    /** 后缀 */
    suffix: { type: String, default: undefined },
    /** input 类型 */
    type: { type: String as PropType<'text' | 'password'>, default: 'text' },
    /** 输入的条件判断 */
    rules: { type: Array as PropType<((value: string) => boolean | string)[]>, default: undefined },
    /** 占位文本 */
    placeholder: { type: String, default: undefined },
    modelValue: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isFocused: false,
      showPassword: false,
      obeyRules: true,
      warningMessage: '',
    };
  },
  computed: {
    /** 标签是否悬浮在左上角 */
    shouldLabelFloating(): boolean {
      return this.label !== undefined && (this.isFocused || Boolean(this.modelValue));
    },
    /** hint 是否显示 */
    isHintVisible(): boolean {
      return this.hint !== undefined && (this.isFocused || this.persistentHint);
    },
  },
  watch: {
    modelValue() {
      this.validate();
    },
  },
  methods: {
    handleChangeValue(event: InputEvent) {
      const val = (event.target as HTMLInputElement)?.value || '';
      this.$emit('update:modelValue', val);
    },
    handleClickTextField() {
      if (this.disabled) {
        return;
      }
      (this.$refs.input as HTMLInputElement).focus();
    },
    handleInputFocused() {
      this.isFocused = true;
    },
    handleInputBlured() {
      this.isFocused = false;
      this.validate();
    },
    validate() {
      let allObeyed = true;
      if (this.rules !== undefined) {
        this.rules.forEach((rule: (value: string) => string | boolean) => {
          const ruleResult = rule(this.modelValue);
          if (typeof ruleResult === 'string') {
            this.obeyRules = false;
            this.warningMessage = ruleResult;
            allObeyed = false;
          }
        });
        if (allObeyed) {
          this.obeyRules = true;
        }
      }
    },
  },
});
